import React, { useState, useEffect } from "react";
import { Button, Card, CardBody, Container, Row, Col } from "reactstrap";
import { withTranslation } from "react-i18next";
import Snackbars from "../../../Utils/Snackbars";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import useRequests from '../../../Utils/useRequests';
import AddRulesToDigBy from "./AddRulesToDigBy";
import EditRulesToDigBy from "./EditRulesToDigBy";
import ChangeStatusRulesToDigBy from "./ChangeStatusRulesToDigBy";
import DeleteRulesToDigBy from "./DeleteRulesToDigBy";
import { useHistory } from "react-router-dom";

const RulesToDigBy = props => {
  const language = props.i18n?.language || localStorage.getItem("I18N_LANGUAGE") || "eng";
  const { getRequest } = useRequests();
  const [AlertData, setAlertData] = React.useState({
    variant: '',
    message: '',
  });
  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: '',
        message: '',
      }));
    }, 5000);
  };
  const history = useHistory();
  React.useEffect(() => {
    if (localStorage.getItem('admin_type') !== 'admin') {
      history.replace('/dashboard');
    }
  }, [history]);
  const [data, setData] = useState([]);
  const [modalAdd, setModalAdd] = useState({ open: false, parent: null });
  const [modalEdit, setModalEdit] = useState({ open: false, item: null });
  const [modalStatus, setModalStatus] = useState({ open: false, item: null });
  const [modalDelete, setModalDelete] = useState({ open: false, item: null });

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    const res = await getRequest('get-rules-to-dig-by');
    if (res && res.code === 200) {
      console.log(res.data);
      setData(res.data || []);
    }
  };

  const renderTree = (items, level = 0) => (
    <ul
      style={{
        listStyle: "none",
        paddingLeft: 0,
        display: "flex",
        flexDirection: level === 0 ? "row" : "column",
        flexWrap: level === 0 ? "wrap" : "nowrap",
        marginBottom: 0,
      }}
    >
      {items.map(item => (
        <li
          key={item.rtdb_id}
          style={{
            margin: level === 0 ? "1.25rem 0 0 0" : "8px 0",
            marginLeft: item.parent_id !== null && level !== 0 ? 32 : 0,
            width: item.parent_id !== null && level !== 0 ? "fit-content" : "100%",
            maxWidth: "100%",
            border: level === 0 ? "2px solid #007bff" : "none",
            borderRadius: level === 0 ? "8px" : "0",
            padding: level === 0 ? "24px" : "0",
            background: level === 0 ? "#f8f9fa" : "transparent",
            boxShadow: level === 0 ? "0 2px 8px rgba(0,0,0,0.05)" : "none"
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            {item.parent_id !== null && (
              <input type="checkbox" style={{ marginRight: 8 }} disabled />
            )}
            <span style={{ fontWeight: "bold" }}>
              {language === "sp"
                ? item.title_sp || item.title_eng || "-"
                : item.title_eng || item.title_sp || "-"}
              <span style={{
                marginLeft: 8,
                color: item.status === "Enable" ? "green" : "red",
                fontWeight: "normal",
                fontSize: "0.9em"
              }}>
                [{item.status === "Enable" ? "Enable" : "Disable"}]
              </span>
            </span>
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginLeft: 8 }}>
              <Button
                size="sm"
                className="mx-1 p-1"
                style={{
                  height: "24px",
                  width: "24px",
                  minWidth: "24px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
                title="Edit"
                onClick={() => setModalEdit({ open: true, item })}
              >
                <i className="fas fa-edit" style={{ fontSize: "12px" }} />
              </Button>
              <Button
                size="sm"
                color={item.status === "Enable" ? "warning" : "success"}
                className="mx-1 p-1"
                style={{
                  height: "24px",
                  width: "24px",
                  minWidth: "24px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
                title={item.status === "Enable" ? "Disable" : "Enable"}
                onClick={() => setModalStatus({ open: true, item })}
              >
                <i className={`fas fa-toggle-${item.status === "Enable" ? "on" : "off"}`} style={{ fontSize: "12px" }} />
              </Button>
              {/* <Button
                size="sm"
                color="danger"
                className="mx-1 p-1"
                style={{
                  height: "24px",
                  width: "24px",
                  minWidth: "24px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
                title="Delete"
                onClick={() => setModalDelete({ open: true, item })}
              >
                <i className="fas fa-trash" style={{ fontSize: "12px" }} />
              </Button>
              <Button
                size="sm"
                className="mx-1 p-1"
                style={{
                  height: "24px",
                  width: "24px",
                  minWidth: "24px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
                title="Add Sub"
                onClick={() => setModalAdd({ open: true, parent: item })}
              >
                <i className="fas fa-plus" style={{ fontSize: "12px" }} />
              </Button> */}
            </div>
          </div>
          {item.children && item.children.length > 0 && (
            <div style={{ marginLeft: 24 }}>
              {renderTree(item.children, level + 1)}
            </div>
          )}
        </li>
      ))}
    </ul>
  );

  return (
    <React.Fragment>
      {AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={props.t("Utilize Safety")} breadcrumbItem={props.t("Rules To Dig By")} />
          {/* <Row className="mb-3">
            <Col className="text-end">
              <Button color="primary" onClick={() => setModalAdd({ open: true, parent: null })}>+ {props.t("Add Main")}</Button>
            </Col>
          </Row> */}
          <Row>
            <Col lg="12">
              <Card>
                <CardBody style={{ paddingTop: "unset !important" }}>
                  {renderTree(data)}
                </CardBody>
              </Card>
            </Col>
          </Row>
          {modalAdd.open && (
            <AddRulesToDigBy
              parent={modalAdd.parent}
              onClose={(variant, message) => {
                setModalAdd({ open: false, parent: null });
                loadData();
                if(variant && message) {
                  setAlertData((AlertData) => ({
                    ...AlertData,
                    variant,
                    message
                  }));
                  resetAlertData();
                }
              }}
            />
          )}
          {modalEdit.open && (
            <EditRulesToDigBy
              item={modalEdit.item}
              onClose={(variant, message) => {
                setModalEdit({ open: false, item: null });
                loadData();
                if(variant && message) {
                  setAlertData((AlertData) => ({
                    ...AlertData,
                    variant,
                    message
                  }));
                  resetAlertData();
                }
              }}
            />
          )}
          {modalStatus.open && (
            <ChangeStatusRulesToDigBy
              item={modalStatus.item}
              onClose={(variant, message) => {
                setModalStatus({ open: false, item: null });
                loadData();
                if (variant && message) {
                  setAlertData((AlertData) => ({
                    ...AlertData,
                    variant,
                    message
                  }));
                  resetAlertData();
                }
              }}
            />
          )}
          {modalDelete.open && (
            <DeleteRulesToDigBy
              item={modalDelete.item}
              onClose={(variant, message) => {
                setModalDelete({ open: false, item: null });
                loadData();
                if (variant && message) {
                  setAlertData((AlertData) => ({
                    ...AlertData,
                    variant,
                    message
                  }));
                  resetAlertData();
                }
              }}
            />
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(RulesToDigBy);